<template>
	<div class="text-submission" ref="square" :style="{ padding }">
		<div class="text-submission__bounds">
			<h2 :style="{ fontSize }">{{ text }}</h2>
			<div
				v-if="!measured"
				ref="measureBounds"
				class="text-submission__measure"
			>
				<h2 ref="measureText" :style="{ fontSize: testFontSize }">
					{{ text }}
				</h2>
			</div>
		</div>
	</div>
</template>

<script>
const PADDING_PCT = 0.077
const FONT_SIZE_STEPS = [0.1, 0.082, 0.064]

const getPadding = side => Math.round(side * PADDING_PCT) + 'px'
const getFontSize = (side, step) =>
	Math.round(side * FONT_SIZE_STEPS[step]) + 'px'

export default {
	name: 'TextSubmission',
	props: {
		text: String
	},
	data() {
		return {
			side: 0,
			testFontStep: 0,
			fontStep: 0,
			measured: false
		}
	},
	computed: {
		padding() {
			return getPadding(this.side)
		},
		testFontSize() {
			return getFontSize(this.side, this.testFontStep)
		},
		fontSize() {
			return getFontSize(this.side, this.fontStep)
		}
	},
	methods: {
		measureSquare() {
			this.side = this.$refs.square.offsetWidth
		},
		checkOverflow() {
			return (
				this.$refs.measureText.offsetHeight >
				this.$refs.measureBounds.offsetHeight
			)
		},
		setFontSize() {
			while (
				this.testFontStep < FONT_SIZE_STEPS.length - 1 &&
				this.checkOverflow()
			) {
				this.testFontStep++
			}
			this.fontStep = this.testFontStep
			this.measured = true
		}
	},
	mounted() {
		this.measureSquare()
		window.addEventListener('resize', this.measureSquare)
		this.$nextTick(this.setFontSize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.measureSquare)
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.text-submission {
	@extend %abs-full;

	&__bounds {
		@extend %flex-row;
		position: relative;
		width: 100%;
		height: 100%;
	}

	&__measure {
		@extend %abs-full;
		@extend %flex-row;
		opacity: 0;
		pointer-events: none;
	}

	h2 {
		@extend %quote;
		@extend %break-word;
		font-size: inherit;
		width: 100%;
		margin: 0;
	}
}
</style>
